export default __webpack_public_path__ + "static/media/Zina1.bb136ba8.png";